import {
  loadBusinessLines, createBusinessLine, editBusinessLine, deleteBusinessLine, verifyBusinessLine,
  createInterest, loadInterests, editInterest, deleteInterest, verifyInterest,
  createLanguageSpoken, loadLanguagesSpoken, editLanguageSpoken, deleteLanguageSpoken, verifyLanguageSpoken,
} from 'store/actions/dictionaries.actions';

export const businessLinesConfig = {
  actions: {
    create: createBusinessLine,
    load: loadBusinessLines,
    edit: editBusinessLine,
    delete: deleteBusinessLine,
    verify: verifyBusinessLine,
  },
  translations: {
    create: 'business_lines.create_business_line',
    edit: 'business_lines.edit_business_line',
    editAndVerify: 'business_lines.edit_and_verify_business_line',
    tableColumnName: 'business_lines.table_name',
    tableColumnStatus: 'business_lines.table_status',
    verifyConfirm: 'business_lines.verify_business_line_confirm',
    verify: 'business_lines.verify_business_line',
    deleteConfirm: 'business_lines.delete_business_line_confirm',
    formNameAlreadyExisted: 'business_lines.form_name_already_existed',
    formName: 'business_lines.form_name',
    formNameValidation: 'business_lines.form_name_validation',
    formNamePlaceholder: 'business_lines.form_name_placeholder',
  },
};

export const interestsConfig = {
  actions: {
    create: createInterest,
    load: loadInterests,
    edit: editInterest,
    delete: deleteInterest,
    verify: verifyInterest,
  },
  translations: {
    create: 'interests.create_interest',
    edit: 'interests.edit_interest',
    editAndVerify: 'interests.edit_and_verify_interest',
    tableColumnName: 'interests.table_name',
    tableColumnStatus: 'interests.table_status',
    verifyConfirm: 'interests.verify_interest_confirm',
    verify: 'interests.verify_interest',
    deleteConfirm: 'interests.delete_interest_confirm',
    formNameAlreadyExisted: 'interests.form_name_already_existed',
    formName: 'interests.form_name',
    formNameValidation: 'interests.form_name_validation',
    formNamePlaceholder: 'interests.form_name_placeholder',
  },
};

export const languagesSpokenConfig = {
  actions: {
    create: createLanguageSpoken,
    load: loadLanguagesSpoken,
    edit: editLanguageSpoken,
    delete: deleteLanguageSpoken,
    verify: verifyLanguageSpoken,
  },
  translations: {
    create: 'languages_spoken.create_language_spoken',
    edit: 'languages_spoken.edit_language_spoken',
    editAndVerify: 'languages_spoken.edit_and_verify_language_spoken',
    tableColumnName: 'languages_spoken.table_name',
    tableColumnStatus: 'languages_spoken.table_status',
    verifyConfirm: 'languages_spoken.verify_language_spoken_confirm',
    verify: 'languages_spoken.verify_language_spoken',
    deleteConfirm: 'languages_spoken.delete_language_spoken_confirm',
    formNameAlreadyExisted: 'languages_spoken.form_name_already_existed',
    formName: 'languages_spoken.form_name',
    formNameValidation: 'languages_spoken.form_name_validation',
    formNamePlaceholder: 'languages_spoken.form_name_placeholder',
  },
};
